export const currencyList = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'IDR',
    value: 'IDR',
  },
  {
    label: 'THB',
    value: 'THB',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
  {
    label: 'ZAR',
    value: 'ZAR',
  },
  {
    label: 'BRL',
    value: 'BRL',
  },
  {
    label: 'MYR',
    value: 'MYR',
  },
  {
    label: 'NGN',
    value: 'NGN',
  },
]

export const leverageList = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '100',
    value: '100',
  },
  {
    label: '200',
    value: '200',
  },
  {
    label: '400',
    value: '400',
  },
  {
    label: '500',
    value: '500',
  },
  {
    label: '600',
    value: '600',
  },
  {
    label: '800',
    value: '800',
  },
  {
    label: '1000',
    value: '1000',
  },
  {
    label: '2000',
    value: '2000',
  },
  {
    label: '210000000',
    value: '210000000',
  },
]
